import { Instagram, MessageCircle, Mail } from "lucide-react";
import { createWhatsAppLink, DEFAULT_WHATSAPP_MESSAGE } from "@/lib/whatsapp";
import logo from "@/assets/logo-preta-ftransp.png";
import logoDark from "@/assets/logo-ftransp.png";
import { useTheme } from "@/context/ThemeContext";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme();

  return (
    <footer className="bg-charcoal text-cream">
      <div className="container-narrow section-padding">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Brand */}
          <div>
            <img
              src={theme === "dark" ? logo : logoDark}
              alt="Solar Crocheteria"
              className="h-12 w-auto mb-4"
            />
            <p className="text-cream/70 text-sm leading-relaxed mb-6">
              Crochê artesanal que veste carinho, exclusividade e estilo.
              Cada peça é única.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/solarcrocheteria"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-cream/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={createWhatsAppLink(DEFAULT_WHATSAPP_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-cream/20 transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Links</h4>
            <nav className="flex flex-col gap-3">
              <a href="#produtos" className="text-cream/70 hover:text-cream transition-colors text-sm">
                Produtos
              </a>
              <a href="#sobre" className="text-cream/70 hover:text-cream transition-colors text-sm">
                Sobre
              </a>
              <a href="#faq" className="text-cream/70 hover:text-cream transition-colors text-sm">
                FAQ
              </a>
              <a href="/admin" className="text-cream/70 hover:text-cream transition-colors text-sm">
                Área Administrativa
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              <a
                href={createWhatsAppLink(DEFAULT_WHATSAPP_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-cream/70 hover:text-cream transition-colors text-sm"
              >
                <MessageCircle className="w-4 h-4" />
                Falar no WhatsApp
              </a>
              <a
                href="mailto:solarcrochetaria@outlook.com"
                className="flex items-center gap-3 text-cream/70 hover:text-cream transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                solarcrochetaria@outlook.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-cream/50 text-sm">
              © {currentYear} Solar Crocheteria. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 text-cream/50 text-xs">
              <span>Pagamento seguro via</span>
              <span className="font-semibold text-cream/70">PagSeguro</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
